import { defineStore } from 'pinia';

export const useLangStore = defineStore('lang', {
  state: () => ({
    language: localStorage.getItem('language') || 'tr'
  }),
  actions: {
    setLanguage(lang) {
      this.language = lang;
      localStorage.setItem('language', lang);
    }
  }
});